import React, { Component } from "react";
import { precisionRound } from "../lib/utils";
import { mean, inverseCumulative } from"../lib/prob";

class Stats extends Component {
    render() {
        return <div className="stats">
            <p>Total is expected to be about { precisionRound(mean(this.props.probDistFn), 1) } { this.props.unit }.</p>
            <ul>
                <li>
              likely to be greater than { inverseCumulative(this.props.probDistFn, 0.05)[0] } { this.props.unit }{ " " }
                    <span className="probability">(p&nbsp;=&nbsp;95%)</span>
                </li>
                <li>
              has a 50% chance of exceeding { inverseCumulative(this.props.probDistFn, 0.5)[0] } { this.props.unit }
                </li>
                <li>
              likely to be less than { inverseCumulative(this.props.probDistFn, 0.95)[1] } { this.props.unit }{ " " }
                    <span className="probability">(p&nbsp;=&nbsp;95%)</span>
                </li>
            </ul>
        </div>;
    }
}

export default Stats;


// WEBPACK FOOTER //
// ./src/components/Stats.js